var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuppliersV2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.7251 48C52.0733 49.2385 50.0646 49.9082 48 49.9082C45.9354 49.9082 43.9267 49.2385 42.2749 48",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9834 91.8917V83.8536C89.9915 82.6905 89.7304 81.5413 89.2206 80.4959C88.7108 79.4506 87.966 78.5371 87.0444 77.8272C81.9683 73.9379 69.8696 67.0831 48 67.0831C26.1305 67.0831 14.0508 73.9532 8.95555 77.8272C8.03413 78.5371 7.28939 79.4506 6.77959 80.4959C6.26976 81.5413 6.00867 82.6905 6.01672 83.8536V91.8917",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3667 39.4124C39.8399 39.4124 39.4127 38.9852 39.4127 38.4583C39.4127 37.9313 39.8399 37.5041 40.3667 37.5041",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3667 39.4124C40.8938 39.4124 41.3208 38.9852 41.3208 38.4583C41.3208 37.9313 40.8938 37.5041 40.3667 37.5041",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6333 39.4124C55.1066 39.4124 54.6792 38.9852 54.6792 38.4583C54.6792 37.9313 55.1066 37.5041 55.6333 37.5041",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6333 39.4124C56.1604 39.4124 56.5874 38.9852 56.5874 38.4583C56.5874 37.9313 56.1604 37.5041 55.6333 37.5041",
    stroke: "currentColor",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3752 30.825H76.625",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2407 8.94021C36.5651 10.3847 32.4751 13.289 29.5704 17.2274C26.6657 21.1659 25.0991 25.9312 25.1001 30.8249V38.4583C25.1001 44.5316 27.5128 50.3563 31.8074 54.6508C36.102 58.9457 41.9269 61.3584 48 61.3584C54.0735 61.3584 59.8983 58.9457 64.1928 54.6508C68.4876 50.3563 70.9 44.5316 70.9 38.4583V30.8249C70.9011 25.9312 69.3344 21.1659 66.4299 17.2274C63.525 13.289 59.4352 10.3847 54.7593 8.94021",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4502 30.8249L54.3702 7.12728C54.1878 6.27344 53.7178 5.508 53.0393 4.95861C52.3608 4.40921 51.5144 4.10909 50.6412 4.10829H45.3588C44.486 4.10909 43.6396 4.40921 42.9607 4.95861C42.2822 5.508 41.8126 6.27344 41.6301 7.12728L36.5501 30.8249",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15.5583V23.1917",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9169 69.0868V84.2583",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2834 91.8917V71.3159",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0835 69.0868V84.2583",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7168 91.8917V71.3159",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0835 84.2583H28.9169V91.8917H67.0835V84.2583Z",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67.0831V84.2583",
    stroke: "currentColor",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuppliersV2);
export default __webpack_public_path__ + "static/media/suppliers-v2.ccc6a66e749d6e36b0aaaaeec1f8b226.svg";
export { ForwardRef as ReactComponent };